import clsx from "clsx";
import SelectedGuestItem from "./SelectedGuestItem";
import { AttendeeType } from "../../../types/block/type";

import styles from "./GuestModal.module.css";

interface SelectedGuestListProps {
  selectedGuests: AttendeeType[];
  expand: boolean;
  handleDelGuest: (email: string) => void;
  isSelfTask: boolean;
  contactData: any;
}

const SelectedGuestList = ({
  selectedGuests,
  expand,
  handleDelGuest,
  isSelfTask,
  contactData,
}: SelectedGuestListProps) => {
  return (
    <div
      className={clsx({
        [styles["selected-guest-wrap"]]: !expand,
        [styles["selected-guest-wrap--expand"]]: expand,
      })}
    >
      {selectedGuests?.map(
        (guest) =>
          guest?.organizer && (
            <SelectedGuestItem
              key={guest.email}
              data={contactData}
              email={guest.email}
              responseStatus={guest.responseStatus}
              onDelete={handleDelGuest}
              isSelfTask={isSelfTask}
              organizer
            />
          )
      )}
      {selectedGuests?.map(
        (guest) =>
          !guest?.organizer && (
            <SelectedGuestItem
              key={guest.email}
              data={contactData}
              email={guest.email}
              responseStatus={guest.responseStatus}
              onDelete={handleDelGuest}
              isSelfTask={isSelfTask}
              organizer={guest.organizer ?? false}
            />
          )
      )}
    </div>
  );
};

export default SelectedGuestList;
